import {createContext, useContext, ReactNode, useRef} from "react";

type AudioContextType = {
    play: (audio: HTMLAudioElement) => Promise<void>;
    pause: () => void;
};

const AudioContext = createContext<AudioContextType | null>(null);

export const useAudio = () => useContext(AudioContext)!;

export function AudioProvider({ children }: { children: ReactNode }) {

    const currentAudio = useRef<HTMLAudioElement | null>(null);

    const play = async (audio: HTMLAudioElement) => {
        try {
            if (currentAudio.current) {
                currentAudio.current.pause();
                currentAudio.current.currentTime = 0;
            }
            currentAudio.current = audio;
            await audio.play();
        } catch (err) {
            console.warn("Audio playback failed:", err);
        }

    }

    const pause = () => {
        if (currentAudio.current) {
            currentAudio.current.pause();
        }
    }

    return (
        <AudioContext.Provider value={{ play, pause }}>
            {children}
        </AudioContext.Provider>
    );
}
